/**
 * Common styled components for Trade Reconditioning Cost components
 * This file contains ALL styled components used across the trade recon cost feature
 */

import styled from 'styled-components';

// ============================================================================
// TRADERECON COST CARD
// ============================================================================

export const CardContainer = styled('div')({
    padding: '24px',
    position: 'relative'
});

export const SettingsButtonWrapper = styled('div')({
    position: 'absolute',
    top: '24px',
    right: '24px',
    zIndex: 1
});

export const NoTradesContainer = styled('div')({
    padding: '24px'
});

// ============================================================================
// TRADERECON ITEMS LIST
// ============================================================================

export const ItemsListContainer = styled('div')({});

export const ReconItemRow = styled('div')({
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    marginBottom: '12px'
});

export const ItemInputWrapper = styled('div')({
    flex: 1
});

export const ItemRemoveButtonWrapper = styled('div')({
    paddingTop: '24px'
});

// ============================================================================
// TRADERECON SINGLE TRADE
// ============================================================================

interface TradeContainerProps {
    isLastTrade: boolean;
}

export const TradeContainer = styled('div')<TradeContainerProps>(({ isLastTrade }) => ({
    marginBottom: !isLastTrade ? '32px' : 0,
    paddingBottom: !isLastTrade ? '10px' : 0,
    borderBottom: !isLastTrade ? '1px solid' : 'none',
    borderColor: 'divider'
}));

export const TradeHeader = styled('div')({
    marginBottom: '16px'
});

export const TotalDivider = styled('div')({
    paddingTop: '5px',
    borderBottom: '1px solid',
    borderColor: 'divider'
});

export const TotalWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: '10px',
    gap: '8px'
});

// ============================================================================
// TRADERECON VALUATION SECTION
// ============================================================================

export const ValuationContainer = styled('div')({
    marginBottom: '24px'
});

export const InputsGrid = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    maxWidth: '528px' // Add this property to reduce the width
});

// ============================================================================
// TRADERECON COST SETTINGS
// ============================================================================

export const SettingsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: 'background.paper'
});

export const BackNavigation = styled('div')({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    cursor: 'pointer',
    color: 'primary.main'
});

export const ScrollableContent = styled('div')({
    flex: 1,
    overflowY: 'auto'
});

export const ReconItemsSection = styled('div')({
    marginBottom: '26px',
    marginTop: '10px'
});

export const SettingsReconItemRow = styled('div')({
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-end',
    marginBottom: '12px'
});

export const SettingsInputWrapper = styled('div')({
    flex: 1
});

export const CheckboxWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: '8px'
});

export const SettingsRemoveButtonWrapper = styled('div')({
    paddingBottom: '8px'
});

export const TradePayoffSection = styled('div')({});

export const FooterContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 16px;
    min-height: 42px;
    background-color: #e4e5e6;
    border-top: 1px solid #e0e0e0;
    flex-shrink: 0;
    margin-top: auto;
`;

export const FooterButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

// Deprecated - use FooterContainer instead
export const SettingsFooter = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '16px 24px',
    backgroundColor: 'background.default'
});
